import { render, staticRenderFns } from "./SelectedProductCard.vue?vue&type=template&id=6caf2ee9&scoped=true&"
import script from "./SelectedProductCard.vue?vue&type=script&lang=js&"
export * from "./SelectedProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductCard.vue?vue&type=style&index=0&id=6caf2ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf2ee9",
  null
  
)

export default component.exports